// extracted by mini-css-extract-plugin
module.exports = {"popover":"i_1","cross":"i_2","container":"i_3","loading":"i_4","message":"i_5","label":"i_6","code":"i_7","button":"i_8","heading":"i_9"};